import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";

const StepHipoteses = ({ hipoteses, onChange, onSave, readOnly }) => (
  <Card>
    <CardHeader><CardTitle>Hipóteses e Descarte</CardTitle></CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label>Hipótese principal</Label>
        <Input value={hipoteses?.principal || ""} disabled={readOnly} onChange={(e) => onChange({ ...hipoteses, principal: e.target.value })} />
      </div>
      {!readOnly && <Button onClick={onSave}>Salvar</Button>}
    </CardContent>
  </Card>
);

export default StepHipoteses;
